import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import Tabs from "../../CommonComponents/Tabs";
import Table from "./Table";
import Pagination from "./Pagination";
import { useRollId } from "../../CommonComponents/RollIdContext";
import { formatAmount } from "../../../../../Util";

const MainContent = ({ rollId, userType: propUserType }) => {
  const { userType: paramUserType } = useParams();
  const location = useLocation();
  const userType = propUserType || paramUserType;
  const isMonazam = userType === "monazam";
  
  const [selectedCurrency, setSelectedCurrency] = useState("PKR");
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    setSelectedCurrency("PKR");
  }, [location.pathname]);

  const handleCurrencySelect = (currency) => {
    setSelectedCurrency(currency);
  };

  return (
    <div className="container-fluid main-content-table bgColor d-flex flex-column overflow-hidden ">
      <hr />

      {/* Transfers and Unclaimed Requests Tabs */}

      <div className="flex-grow-1 d-flex flex-column pt-2">
        <div className="row mb-4 align-items-start">
          {/* Balance and Add Button Section */}
          <div className="col-md-12 d-flex justify-content-end align-items-center mt-3 mt-md-0">
            {rollId === "monazam" && (
              <button
                className="d-flex justify-content-center align-items-center me-3 add-button"
              >
                <FaPlus className="me-1 greenplusbtn" />
              </button>
            )}
            <div className="balance-box p-2 border-2">
              <div>
                <div className="balance-txt">Balance</div>
                <div className="amount-txt fw-bold">{`SAR ${amount.toLocaleString()}`}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-wrapper marginRight flex-grow-1 p-3 rounded shadow-sm d-flex flex-column">
          <div
            className="table-container scroll flex-grow-1"
          >
            <Table setAmount={setAmount} isMonazam={isMonazam} />
          </div>

          {/* Pagination and Export Button */}
          <div className="d-flex justify-content-end align-items-center mt-3 flex-wrap">
            <Pagination />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
